// Copyright 2018 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { Point3D } from "datatypes/SoramaLocalApi";
import { IModal } from "libraries/WorkflowFramework/Interfaces/IModal";
import { IWorkflowModuleModalInstance } from "libraries/WorkflowFramework/Interfaces/IWorkflowModule";
import { ChannelSelection } from "services/ChannelSelection/ChannelSelection";

@autoinject()
export class ManualChannelSelectionModal implements IModal<
    ManualChannelSelectionModalState,
    ManualChannelSelectionModalReturnState
> {
    private channelSelection: ChannelSelection;
    private microphonePositions: Point3D[];

    private modalInstance: IWorkflowModuleModalInstance<
        ManualChannelSelectionModalState,
        ManualChannelSelectionModalReturnState
    >;

    public activateModal(
        state: ManualChannelSelectionModalState,
        modalInstance: IWorkflowModuleModalInstance<
            ManualChannelSelectionModalState,
            ManualChannelSelectionModalReturnState
        >
    ): void {
        this.channelSelection = new ChannelSelection(state.selectedSelection);
        this.microphonePositions = state.microphonePositions;

        this.modalInstance = modalInstance;
    }

    public close(): ManualChannelSelectionModalReturnState {
        return <ManualChannelSelectionModalReturnState>{
            microphonePositions: this.microphonePositions,
            selectedSelection: this.channelSelection.getSelection(),
        };
    }

    private selected(): void {
        this.modalInstance.close();
    }
}

// View-Model for modal needs to be first class in the file
export class ManualChannelSelectionModalState {
    public microphonePositions: Point3D[];
    public selectedSelection: boolean[];
}

export class ManualChannelSelectionModalReturnState {
    public microphonePositions: Point3D[];
    public selectedSelection: boolean[];
}
